import { Heading, LiliButton, FontWeight, Text } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import LiliLogo from '@Assets/logos/lili-logo-blue.svg';
import TrustpilotText from '@Components/TrustpilotText/TrustpilotText';
import { useAccountantPortalWelcomeLogic } from './hooks/useAccountantPortalWelcomeLogic';

export const AccountantPortalWelcome = () => {
  const { t } = useTranslation('inviteTeamMember');
  const { handleGetStarted, isLoading } = useAccountantPortalWelcomeLogic();

  return (
    <div className='bg-surface-primary-bw-00 flex flex-col items-center justify-center w-full min-h-screen'>
      <div className='flex flex-col items-center gap-[48px] max-w-[450px] w-full'>
        <img
          src={LiliLogo}
          alt={t('accountantPortalWelcome.logoAlt')}
          className='w-[56px] h-[51.287px]'
        />
        <div className='flex flex-col items-center gap-[56px] w-full'>
          <div className='flex flex-col items-center gap-[16px] text-center w-[324px]'>
            <Heading.H3 fontWeight={FontWeight.SEMIBOLD} className='tracking-[-1px]'>
              {t('accountantPortalWelcome.title')}
            </Heading.H3>
            <Text.H9 className='text-text-main-primary tracking-[-0.2px]'>
              {t('accountantPortalWelcome.subtitle')}
            </Text.H9>
          </div>
          <div className='flex flex-col items-center justify-center gap-[24px] w-full'>
            <LiliButton
              id='get-started-button'
              title={t('accountantPortalWelcome.getStarted')}
              onClick={handleGetStarted}
              isLoading={isLoading}
              className='w-[226px] px-[40px] py-[15px] h-[54px]'
            />
            <TrustpilotText />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountantPortalWelcome;
